import React from "react";
import { Gem } from "lucide-react";
import { PlatinumPanel } from "@/components/PlatinumPanel";

export default function Platinum() {
  return (
    <div className="space-y-3" data-testid="platinum-page">
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight flex items-center gap-2"><Gem className="h-5 w-5 text-slate-500" /> TFR Platinum</h1>
        <p className="text-xs text-slate-500 mt-0.5 font-mono">stocks in at least two of TFR Prime, TFR Gold and Power Scan, same direction · ALL 3 = in every one · time = when it entered each scanner</p>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-3.5">
        <PlatinumPanel />
      </div>
    </div>
  );
}
